<template>
  <div id="com">
    <navheader></navheader>
    <fixheader></fixheader>
    <carousel></carousel>
    <about></about>
    <!-- <honor></honor> -->
    <organizations></organizations>
    <news></news>
    <cooperation></cooperation>
    <contact></contact>
    <foot></foot>
    <filing></filing>
  </div>
</template>

<script>
  import navheader from '@/components/Navheader.vue'
  import fixheader from '@/components/Fixheader.vue'
  import carousel from '@/components/Carousel.vue'
  import organizations from '@/components/Organizations.vue'
  import about from '@/components/About.vue'
  import honor from '@/components/Honor.vue'
  import contact from '@/components/Contact.vue'
  import foot from '@/components/Foot.vue'
  import filing from '@/components/Filing.vue'
  import customer from '@/components/Customer.vue'
  import cooperation from '@/components/Cooperation.vue'
  import news from '@/components/News.vue'
  export default {
    name: 'com',
    components: {
      navheader,
      fixheader,
      carousel,
      organizations,
      about,
      honor,
      contact,
      foot,
      filing,
      customer,
      cooperation,
      news
    },

  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Com.vue